<!-- <p class="text-center title-xs font-serra my-4">Aperçu partagé</p> -->
<h1 class="text-center my-4">Aperçu partagé</h1>
<div class="text-center mb-4">
	<span class="opacity-60 tracking-wide">Contenu partagé depuis</span>
	<a href="#" [routerLink]="router.get('login')">
		<img class="img-app" src="img/logo/logo-trasnparent.png"/>
	</a>
	<lgb-brand></lgb-brand>
</div>
<fieldset class="fieldset text-center mb-4">
	Certaines fonctionnalités sont disponibles uniquement dans l’application.
	<!-- <div class="icon-container mb-2">
		<div class="icon-element text-center">
			<img src="img/skin/scan.new.png"/>
			<div>
				<span class="title-icon">Scanner</span>
				des cartes
			</div>
		</div>

		<div class="icon-element text-center">
			<img src="img/skin/prices.new.png"/>
			<div>
				<span class="title-icon">Estimation</span>
				automatique
			</div>
		</div>

		<div class="icon-element text-center">
			<img src="img/skin/orga.new.png"/>
			<div>
				<span class="title-icon">Organisation</span>
				simplifiées
			</div>
		</div>

		<div class="icon-element text-center">
			<img src="img/skin/share.new.png"/>
			<div>
				<span class="title-icon">Partage</span>
				par lien
			</div>
		</div>
	</div> -->
</fieldset>
<div class="btn-container mb-4">
	<a href="#" [routerLink]="router.get('login')" class="btn btn-primary btn-gradient">
		Ouvrir l'application
	</a>
</div>